import { Tabs } from '@heroui/react';
import { Link, useLocation } from 'react-router-dom';

const inventoryTabs = [
  { id: 'stock', label: 'Stock', href: '/dashboard/inventario/stock' },
  { id: 'alertas', label: 'Alertas', href: '/dashboard/inventario/alertas' },
  { id: 'plantillas', label: 'Plantillas', href: '/dashboard/inventario/plantillas' },
  { id: 'importar', label: 'Importar', href: '/dashboard/inventario/importar' },
] as const;

function selectedInventoryTab(pathname: string) {
  return inventoryTabs.find((tab) => pathname === tab.href || pathname.startsWith(`${tab.href}/`))?.id ?? 'stock';
}

export function InventoryTabs() {
  const location = useLocation();

  return (
    <div className="mb-5 flex justify-end">
      <Tabs selectedKey={selectedInventoryTab(location.pathname)} variant="secondary" align="end" className="w-full sm:w-auto">
        <Tabs.ListContainer className="overflow-x-auto rounded-2xl border border-[var(--app-brand-line)] bg-white/80 px-3 shadow-sm">
          <Tabs.List aria-label="Navegación de inventario" className="min-w-max">
            {inventoryTabs.map((tab) => (
              <Tabs.Tab
                key={tab.id}
                id={tab.id}
                href={tab.href}
                render={(domProps: any) => <Link {...domProps} to={tab.href} />}
              >
                {tab.label}
                <Tabs.Indicator />
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>
    </div>
  );
}
